import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    realEstate: [],
  },
  mutations: {
    setRealEstate(state, realEstate) {
      Vue.set(state, 'realEstate', realEstate);
    },
  },
  actions: {
    fetchRealEstate({ commit, rootState }) {
      return this.$axios.get(`${rootState.endpoints.filings}/${rootState.filing.currentFilingId}/real-estate`).then(response => {
        return commit('setRealEstate', response.data);
      }).catch(error => {
        return error.message;
      });
    },
  },
};